import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSupport = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "uuid-15fdd3d7-9d6f-46db-b558-81c493eaa17e",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M71.69,66.67c-2.5,5.82-7.28,9.84-13.37,11.6-.62,2.8-3.12,4.7-5.89,4.67s-5.23-2.03-5.79-4.74.89-5.65,3.56-6.75,5.59-.2,7.23,2.13c4.13-1.31,7.59-3.97,9.52-7.95-1.17-1-1.91-2.37-1.91-3.92v-14.77c0-2.19,1.41-4.05,3.4-4.82,1.68-.66,3.48-.41,4.94.65s2.24,2.55,2.24,4.3c1.74-.05,3.17,1.31,3.17,3.04v8.43c0,1.74-1.44,3.07-3.17,3.03,0,2.41-1.6,4.46-3.92,5.1Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M24.39,61.58c-1.71.01-3.1-1.24-3.17-2.97v-8.63c.1-1.69,1.48-2.94,3.17-2.91,0-3.09,2.69-5.57,5.76-5.28,2.67.25,4.71,2.42,4.82,5.09v14.63c.04,2.96-2.32,5.34-5.22,5.37s-5.35-2.26-5.36-5.3Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M58.66,28.07c-5.42-2.81-11.89-2.73-17.23.21-4.32,2.38-7.52,6.38-8.89,11.18-1.64-.6-3.45-.72-5.17-.17,2.91-12.95,15.96-20.93,28.85-17.54,8.39,2.18,15.06,9.06,16.9,17.67-1.76-.62-3.51-.68-5.21-.09-1.41-4.89-4.76-8.95-9.25-11.27Z" })
	]
});
export default SvgSupport;
